import { Pipe, PipeTransform } from '@angular/core';
import {isNullOrUndefined} from 'util';
/**
 * Rc Truncate Pipe
 *
 * @example
 * {{'some long text to truncate' | rcTruncate: 10 }}
 *
 */
@Pipe({
    name: 'rcTruncate'
})
export class RcTruncatePipe implements PipeTransform {

  transform(value: any, length: number = null, extention: string = '...'): any {
    if (isNullOrUndefined(value) || isNullOrUndefined(length)) {
      return value;
    }
    if (value.toString().length <= length) {
      return value;
    }

    return value.toString().substr(0, length - extention.length) + extention;
  }

}
